import { OutstandingAccountant } from './OutstandingAccountant';

export default OutstandingAccountant;
